import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from '@/components/ui/alert-dialog';

export interface ProfileDeleteDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    onDelete: () => void;
    disabled?: boolean;
}

export function ProfileDeleteDialog({
    open,
    onOpenChange,
    onDelete,
    disabled,
}: ProfileDeleteDialogProps) {
    return (
        <AlertDialog open={open} onOpenChange={onOpenChange}>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle>Удалить профиль?</AlertDialogTitle>
                    <AlertDialogDescription>
                        Вы уверены, что хотите удалить этот профиль? Все связанные с ним анкеты и аудиозаписи будут удалены без возможности восстановления.
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel>
                        Отменить
                    </AlertDialogCancel>
                    <AlertDialogAction disabled={disabled} onClick={onDelete}>
                        Удалить
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}
